/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetOlafReprocessJobStatusByReprocessKeyQueryResponse, GetOlafReprocessJobStatusByReprocessKeyPathParams, GetOlafReprocessJobStatusByReprocessKey404 } from "../models/GetOlafReprocessJobStatusByReprocessKey";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getOlafReprocessJobStatusByReprocessKey } from "../axios/getOlafReprocessJobStatusByReprocessKey";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getOlafReprocessJobStatusByReprocessKeyQueryKey = (reprocessKey: GetOlafReprocessJobStatusByReprocessKeyPathParams["reprocessKey"]) => ["audit-reports-api", { url: '/olaf/reprocess/job-status-by-reprocess-key/:reprocessKey', params: {reprocessKey:reprocessKey} }] as const

export type GetOlafReprocessJobStatusByReprocessKeyQueryKey = ReturnType<typeof getOlafReprocessJobStatusByReprocessKeyQueryKey>

export function getOlafReprocessJobStatusByReprocessKeyQueryOptions(reprocessKey: GetOlafReprocessJobStatusByReprocessKeyPathParams["reprocessKey"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getOlafReprocessJobStatusByReprocessKeyQueryKey(reprocessKey)
        return queryOptions<GetOlafReprocessJobStatusByReprocessKeyQueryResponse, ResponseErrorConfig<GetOlafReprocessJobStatusByReprocessKey404>, GetOlafReprocessJobStatusByReprocessKeyQueryResponse, typeof queryKey>({
         enabled: !!(reprocessKey),
         queryKey,
         queryFn: async ({ signal }) => {
            return getOlafReprocessJobStatusByReprocessKey(reprocessKey, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Finds and returns the most recent reprocess job for the given reprocess key within the user's client.
 * @summary Get OLAF reprocess job status by reprocess key
 * {@link /olaf/reprocess/job-status-by-reprocess-key/:reprocessKey}
 */
export function useGetOlafReprocessJobStatusByReprocessKey<TData = GetOlafReprocessJobStatusByReprocessKeyQueryResponse, TQueryData = GetOlafReprocessJobStatusByReprocessKeyQueryResponse, TQueryKey extends QueryKey = GetOlafReprocessJobStatusByReprocessKeyQueryKey>(reprocessKey: GetOlafReprocessJobStatusByReprocessKeyPathParams["reprocessKey"], options: 
{
  query?: Partial<QueryObserverOptions<GetOlafReprocessJobStatusByReprocessKeyQueryResponse, ResponseErrorConfig<GetOlafReprocessJobStatusByReprocessKey404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getOlafReprocessJobStatusByReprocessKeyQueryKey(reprocessKey)
         

         const query = useQuery({
          ...getOlafReprocessJobStatusByReprocessKeyQueryOptions(reprocessKey, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetOlafReprocessJobStatusByReprocessKey404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}